import { useParams, usePathname } from 'next/navigation';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { B2C_LOGIN_URL } from 'constants/links';

export const useLoginUrl = () => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  /*  TODO - Input Validations - usePathName: Validate pathname is a valid
  string with alphanumeric values allowin only two special characters . Slash (/)
  and Dash (-) . UNDER INVESTIGATION - All valid part number characters*/
  const pathname = usePathname();
  const isHomePage = esiteUrl === pathname;

  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl: pathname,
      loginFromHomePage: isHomePage
    })
  );

  return loginUrl;
};
